<template>
  <div>
    <div class="my-2">
      <v-row align="center">
        <v-col cols="12" md="3" class="mt-2">
          <p class="default_txt">Search proposal</p>
          <v-text-field
            placeholder="Search Proposal"
            solo
            dense
            v-model="find"
            @keyup="fetchData"
            hide-details
            prepend-inner-icon="mdi-magnify"
            flat
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" class="mt-2">
          <p class="default_txt">Select type</p>
          <v-select
            :items="optType"
            item-text="name"
            item-value="val"
            v-model="type"
            placeholder="Type"
            flat
            dense
            hide-details
            solo
            @change="fetchData"
          ></v-select>
        </v-col>
        <v-col cols="12" md="2" class="mt-2">
          <p class="default_txt">Select type</p>
          <v-select
            hide-details
            :items="optStatus"
            flat
            item-text="txt"
            solo
            dense
            item-value="val"
            v-model="approval"
            @change="fetchData"
            placeholder="Status"
          ></v-select>
        </v-col>
        <v-col cols="12" md="2" class="mt-2">
          <p class="default_txt">Sort by</p>
          <v-select
            hide-details
            :items="optSort"
            flat
            item-text="txt"
            solo
            dense
            item-value="val"
            v-model="sort"
            @change="fetchData"
            placeholder="Sort data"
          ></v-select>
        </v-col>
        <v-col cols="12" md="3" class="mt-2">
          <div class="d-flex align-center justify-end" style="margin-top: 18px">
            <v-btn
              color="#006341"
              @click="createProposal"
              class="btn text-capitalize"
              depressed
              dark
            >
              Submit Proposal
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="my-2">
      <div v-if="loading">
        <v-card class="my-2 pa-3 rounded-lg" v-for="i in 3" :key="i">
          <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
        </v-card>
      </div>
      <div v-if="dataSet && !loading">
        <div
          v-if="!dataSet.length"
          class="d-flex flex-column align-center justify-center pa-3"
        >
          <img
            src="../../../assets/img/gundam/no_data_general.png"
            height="200px"
            alt=""
          />

          <h3 class="text-center">Data not found</h3>
        </div>
        <div v-if="dataSet.length">
          <v-expansion-panels accordion multiple flat>
            <v-expansion-panel
              v-for="(item, i) in dataSet"
              :key="i"
              class="mb-2 rounded-lg"
            >
              <v-expansion-panel-header>
                <div>
                  <h3 class="mr-2 mb-1 color_default">{{ item.title }}</h3>

                  <div class="d-flex aligm-center">
                    <div class="d-flex align-center">
                      <p class="mb-0 mr-2">
                        Submitted at
                        <b>{{
                          $date(item.created_at).format("DD MMMM YYYY")
                        }}</b>
                      </p>
                      <p class="mb-0">
                        . Type :
                        <b>{{
                          item.destination == "sudah"
                            ? "Already applied"
                            : `Haven't applied yet`
                        }}</b>
                      </p>
                    </div>
                  </div>
                </div>
                <template v-slot:actions>
                  <v-chip
                    dark
                    :color="
                      item.approval == 'approved'
                        ? '#006341'
                        : item.approval == 'declined'
                        ? '#FE0404'
                        : item.approval == 'revision'
                        ? '#B3A369'
                        : '#001A72'
                    "
                    label
                  >
                    {{ item.approval }}
                  </v-chip>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div
                  class="mb-2 d-flex align-start"
                  v-if="item.approval == 'approved'"
                >
                  <v-icon color="#006341" class="mr-1">
                    mdi-square-edit-outline
                  </v-icon>
                  <div style="flex: 1">
                    <h5>Continuation of GEP</h5>
                    <h5>For those who have been accepted for an GEP</h5>
                    <v-row>
                      <v-col cols="6" md="3">
                        <v-card
                          outlined
                          height="100%"
                          color="#E8F5E9"
                          class="pa-3 d-flex flex-column align-center"
                          :to="`/admin/mp/dokumentasi-gep/${item.id}`"
                        >
                          <v-icon color="var(--g)">mdi-content-paste</v-icon>
                          <b class="color_default text-center">
                            Documentation GEP</b
                          >
                        </v-card>
                      </v-col>
                      <v-col cols="6" md="3">
                        <v-card
                          outlined
                          height="100%"
                          color="#E8F5E9"
                          class="pa-3 d-flex flex-column align-center"
                          @click="finalReport(item.id)"
                        >
                          <v-icon color="var(--g)"
                            >mdi-text-box-check-outline</v-icon
                          >
                          <b class="color_default">Final Report</b>
                        </v-card>
                      </v-col>
                    </v-row>
                    <!-- <v-btn
                      style="text-transform: uppercase"
                      color="#006341"
                      depressed
                      class="btn mt-2"
                      :to="`/admin/mp/dokumentasi-gep/${item.proposal_id}`"
                    >
                      <h4 style="color: white; font-weight: normal">
                        Documentation GEP
                      </h4>
                    </v-btn> -->
                  </div>
                </div>

                <div
                  class="d-flex"
                  v-for="(history, k) in item.data_submission"
                  :key="`${k}-hist`"
                >
                  <div class="d-flex flex-column align-center">
                    <div
                      class="dot_out"
                      :style="`background: ${
                        history.history.approval == 'approved'
                          ? '#006341'
                          : history.history.approval == 'declined'
                          ? '#FE0404'
                          : history.history.approval == 'revision'
                          ? '#B3A369'
                          : '#001A72'
                      }`"
                    ></div>
                    <div
                      class="line_graph"
                      :style="`background: ${
                        history.history.approval == 'approved'
                          ? '#006341'
                          : history.history.approval == 'declined'
                          ? '#FE0404'
                          : history.history.approval == 'revision'
                          ? '#B3A369'
                          : '#001A72'
                      }`"
                    ></div>
                  </div>
                  <div class="ml-2" style="flex: 1">
                    <v-card outlined class="pa-2 mb-2">
                      <v-row>
                        <v-col cols="12" md="6">
                          <b class="mb-1 bold small_txt">
                            {{
                              $date(history.history.created_at).format(
                                "dddd, DD MMMM YYYY . HH:mm",
                              )
                            }}
                          </b>
                        </v-col>
                      </v-row>
                      <div>
                        <div class="d-flex align-start">
                          <v-icon small class="mr-2">mdi-link-variant</v-icon>
                          <a
                            :href="history.content"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <p class="mb-0 small_txt">{{ history.content }}</p>
                          </a>
                        </div>
                        <div class="d-flex align-start mt-2">
                          <v-icon small class="mr-2">mdi-text</v-icon>
                          <p class="mb-0 small_txt">
                            {{ history.description }}
                          </p>
                        </div>
                        <div class="d-flex align-start mt-2 pb-1">
                          <v-icon small class="mr-2">mdi-progress-clock</v-icon>
                          <v-card flat class="px-2 d-flex">
                            <b
                              class="small_txt mb-0 mr-2"
                              :style="`color: ${
                                history.history.approval == 'approved'
                                  ? '#006341'
                                  : history.history.approval == 'declined'
                                  ? '#FE0404'
                                  : history.history.approval == 'revision'
                                  ? '#B3A369'
                                  : '#001A72'
                              }`"
                            >
                              {{ history.history.approval }}
                            </b>
                            <p
                              class="small_txt mb-0"
                              v-if="history.history.notes"
                            >
                              : {{ history.history.notes }}
                            </p>
                          </v-card>
                        </div>
                      </div>
                    </v-card>
                    <div
                      class="d-flex justify-end mt-2"
                      v-if="
                        item.data_submission[0].history.approval === 'revision'
                      "
                    >
                      <v-btn
                        small
                        depressed
                        dark
                        color="var(--g)"
                        @click="reviewProp(history, item.title)"
                      >
                        <v-icon small class="mr-1">mdi-pencil</v-icon>
                        Update Submission</v-btn
                      >
                    </div>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <div class="text-center my-2 pa-3">
            <v-pagination
              v-model="page"
              color="#006341"
              @input="fetchData"
              :length="last_page"
            ></v-pagination>
          </div>
        </div>

        <div class="pa-3">
          <dialog-large
            :d_large="d_large"
            @refetch="fetchData"
            @close="d_large = false"
            :inventory="inventory"
            :type="d_type"
            :title="d_title"
            :hide_title="hide_title"
            line="true"
            @changeTitleDialog="changeStep"
            :btnTitle="btnTitle"
            :txtTambahan="txtTambahan"
            :title2="d_title2"
            @minTitleDialog="minStep"
          />
          <update-proposal-scholar
            :r_prop="r_prop"
            @close="r_prop = false"
            @refetch="fetchData"
            :inventory="inventory"
            :title="d_title"
          />
          <final-report-proposal
            :d_fr="d_fr"
            @close="d_fr = false"
            :inventory="inventory"
            :disabled="false"
          />
          <v-snackbar v-model="snack" :timeout="-1"> getting data </v-snackbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import UpdateProposalScholar from "./updateProposalScholar.vue";
import FinalReportProposal from "./proposal/finalReportProposal.vue";
export default {
  name: "proposalGepScholar",
  components: {
    apexchart: VueApexCharts,
    UpdateProposalScholar,
    FinalReportProposal,
  },
  data() {
    return {
      snack: false,
      d_fr: false,
      r_prop: false,
      d_large: false,
      loading: true,
      inventory: "",
      d_type: "",
      d_title: "",
      d_title2: "",
      hide_title: "",
      txtTambahan: "",
      internshipApproved: false,
      internshipApprovedData: null,
      dataSet: null,
      page: 1,
      find: "",
      limit: 10,
      series: [44, 55],
      total: 1,
      last_page: 1,
      proposal: "",
      btnTitle: "",
      type: "",
      approval: "",
      sort: "",
      optSort: [
        { txt: "Normal", val: "" },
        { txt: "Newest", val: "-created_at" },
        { txt: "Oldest", val: "created_at" },
      ],
      optStatus: [
        { txt: "Process", val: "process" },
        { txt: "Approved", val: "approved" },
        { txt: "Declined", val: "declined" },
        { txt: "Revision", val: "revision" },
      ],
      optType: [
        { name: "Already applied", val: "sudah" },
        { name: "Haven't applied yet", val: "belum" },
      ],
      optTypeProposal: [
        { name: "INTERNSHIP", val: "INTERNSHIP" },
        { name: "GEP", val: "GEP" },
        { name: "SPONSORSHIP", val: "SPONSORSHIP" },
      ],
    };
  },
  mounted() {
    this.fetchData();
    this.getQuestion();
  },
  methods: {
    getQuestion() {
      let data = {
        path: `scholar/proposal/gep/question`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.frQuestion = data.data;
          this.frQuestion.forEach((el) => {
            el["answer"] = "";
          });
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    finalReport(id) {
      this.snack = true;
      let data = {
        path: `proposal/gep/report?filter[scholar_gep_proposal_id]=${id}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.frQuestion.forEach((q) => {
            data.data.forEach((a) => {
              if (q.id == a.id) {
                q["answer"] = a.answer;
              }
            });
          });
          this.inventory = {
            question: this.frQuestion,
            path: "scholar/proposal/gep/question",
            id: "scholar_gep_proposal_report_question_id",
            body: {
              scholar_gep_proposal_id: id,
              type: "text",
            },
          };
          this.d_fr = true;
          this.snack = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.snack = false;
        });
    },
    changeStep() {
      this.d_large = false;
      this.updateProposal(this.inventory.data, 2, "");
    },
    minStep() {
      this.d_large = false;
      this.updateProposal(this.inventory.data, 1, "");
    },
    fetchData() {
      this.loading = true;
      let data = {
        path: `scholar/proposal/gep?sort=${this.sort}&filter[type]=${this.type}&filter[approval]=${this.approval}&filter[title]=${this.find}&page[number]=${this.page}&page[size]=${this.limit}&include=dataProposal,dataSubmission`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
          this.loading = false;
          for (let i = 0; i < this.dataSet.length; i++) {
            if (this.dataSet[i].approval == "approved") {
              this.internshipApproved = true;
              this.internshipApprovedData = this.dataSet[i];
              break;
            }
          }
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    createProposal() {
      this.d_type = "c_proposalGepScholar";
      this.d_title = "Instructions";
      this.d_large = true;
      this.hide_title = true;
      this.btnTitle = "";
      this.txtTambahan = "Before submit proposal";
      this.d_title2 = "Submit Proposal";
    },
    reviewProp(item, title) {
      this.d_title = "Update Proposal GEP";
      let body = {
        id: item.scholar_gep_proposal_id,
        description: item.description,
        content: item.content,
        title: title,
      };
      this.inventory = {
        path: `scholar/proposal/gep/update`,
        body: body,
        data: {
          title: title,
          aproval: item.history.approval,
          notes: item.history.notes,
        },
      };
      this.r_prop = true;
    },
    updateProposal(item, view, showBtn) {
      let data = {
        step: view,
        data: item,
      };
      this.d_type = "u_proposalGepScholar";
      this.d_title = view == 1 ? "Detail Proposal GEP" : "Update Proposal";
      this.inventory = data;
      this.d_large = true;
      this.hide_title = true;
      // this.btnTitle = showBtn;
      this.txtTambahan = "";
      this.d_title2 = "";
    },
    row_classes(item) {
      let idx = this.dataSet.indexOf(item);
      if (idx % 2 == 0) {
        return "strip_"; //can also return multiple classes e.g ["orange","disabled"]
      }
    },
  },
};
</script>
<style scoped>
.v-pagination__item {
  box-shadow: none !important;
}
.v-pagination__navigation {
  box-shadow: none !important;
}
.btn {
  text-transform: unset !important;
}
.dot_out {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  /* background: green; */
}
.line_graph {
  width: 2px;
  /* background: green; */
  height: 100%;
  margin-top: -5px;
}
</style>
